import { render, staticRenderFns } from "./ScratchyTemplate.vue?vue&type=template&id=15362096"
import script from "./ScratchyTemplate.vue?vue&type=script&lang=ts"
export * from "./ScratchyTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports